// lib/getTrackingFromCookie.ts
export function getTrackingFromCookie(): string | null {
  if (typeof document === 'undefined') return null

  const parts = document.cookie.split('; ').map((c) => c.split('='))
  const map = Object.fromEntries(parts.map(([k, ...rest]) => [k, rest.join('=')]))

  const raw =
    map.ref ||
    map.invite ||     // legado
    map.tracking      // legado

  return raw ? decodeURIComponent(raw) : null
}